import qwest from 'qwest';

import SystemNote from '../models/systemNote.jsx';

import CustomerApi from './customer.jsx';

import SystemApi from './pool.jsx';

let NotesApi = {
  getList(systemID) {
    return new Promise((resolve, reject) => {
      qwest.get(`/SystemNotes/List?systemID=${systemID}`)
        .then((xhr, response) => {
          if (response.success) {
            let notes = response.data.map(n => SystemNote.fromApiFormat(n));

            resolve(notes);
          } else {
            reject(response);
          }
        });
    });
  },

  save(note, customerID, systemID, invalidateCache = true) {
    return new Promise((resolve, reject) => {
      qwest.post('/SystemNotes', {note: note.toApiFormat()})
        .then((xhr, response) => {
          if (response.success) {
            let notes = response.data.map(n => SystemNote.fromApiFormat(n));

            if (invalidateCache) {
              CustomerApi.getCustomer(customerID);
              SystemApi.getPool(systemID, true);
            }
            resolve(notes);
          } else {
            reject(response);
          }
        });
    });
  },

};

export default NotesApi;
